
  import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
  export default class YouTubePlayer extends Vue {
  /**
   * ID del video de YouTube (ej: https://youtu.be/gTH9Wo3Spto -> "gTH9Wo3Spto")
   */
  @Prop({ default: 'gTH9Wo3Spto' })
  readonly videoId!: string;

  /**
   * Ancho por defecto del reproductor
   */
  @Prop({ default: 250 })
  readonly width!: number;

  /**
   * Alto por defecto del reproductor
   */
  @Prop({ default: 140 })
  readonly height!: number;

  /**
   * Reproducción automática (autoplay)
   */
  @Prop({ default: false })
  readonly autoPlay!: boolean;

  /**
   * Título opcional debajo del video
   */
  @Prop({ default: 'Esto es una prueba' })
  readonly videoTitle!: string;

  /**
   * Modo "limpio": oculta logos, videos sugeridos, etc.
   * Deja solo la interfaz mínima (botón de Play, barra de progreso).
   */
  @Prop({ default: false })
  readonly hideExtraInfo!: boolean;

  /**
   * Construye la URL del video con los parámetros necesarios.
   */
  get videoUrl (): string {
    // URL base sin cookies
    const base = `https://www.youtube-nocookie.com/embed/${this.videoId}`
    const params: string[] = []

    // Modo limpio: ocultar info extra
    if (this.hideExtraInfo) {
      /*
        - modestbranding=1 -> ocultar logo de YT en el player
        - rel=0 -> no mostrar videos relacionados al final
        - showinfo=0 -> (obsoleto pero a veces funciona para ocultar título)
        - controls=1 -> dejar al menos el play y la barra
      */
      params.push('modestbranding=1', 'rel=0', 'showinfo=0', 'controls=1')
    } else {
      // Modo normal: si quieres mostrar controles sí o sí
      params.push('controls=1')
    }

    // Autoplay
    if (this.autoPlay) {
      params.push('autoplay=1')
    }

    // Generar la cadena de consulta
    const joinedParams = params.length ? `?${params.join('&')}` : ''
    return base + joinedParams
  }

  /**
   * Permisos para el iframe (autoplay, etc.)
   */
  get iframeAllow (): string {
    return 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
  }
  }
